export const UPDATE_SCORE = 'UPDATE_SCORE';

export function updateScore(product, answer, score) {
  return {
    type: UPDATE_SCORE,
    payload: {
      product,
      answer,
      score,
    },
  };
}



// WEBPACK FOOTER //
// ./src/modules/funnel/actions/score.js